import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../session.service';

@Injectable()
export class PersonDetailsGuardService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const loginPath = '/login';
    const emailId = localStorage.getItem('usermail');

    if (emailId === null || emailId === undefined) {
      console.log('User not authenticated, redirecting to login page');
      this.router.navigate([loginPath]);
      return false;
    } else {
      console.log('User authenticated, allowing access to personal-details');
      return true;
    }
  }
}

@Injectable()
export class LoginGuardService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const loginPath = '/login';
    const personId = localStorage.getItem('personId');

    if (personId === null || personId === undefined) {
      console.log('User not authenticated, redirecting to login page');
      this.router.navigate([loginPath]);
      return false;
    } else {
      console.log('User authenticated, allowing access');
      return true;
    }
  }
}

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private isRedirecting = false;

  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // ✅ Never block the login page itself
    if (state.url.includes('main-applcation-login')) {
      return true;
    }

    // ✅ Prevent re-entrant calls
    if (this.isRedirecting) {
      return false;
    }

    const token = this.sessionService.getToken();

    if (!token) {
      console.log('🚫 No token - redirecting to login');
      this.isRedirecting = true;
      this.router.navigate(['/main-applcation-login']).then(() => {
        this.isRedirecting = false;
      });
      return false;
    }

    if (this.sessionService.isTokenExpired()) {
      console.log('🚫 Token expired - showing session popup');
      this.isRedirecting = true;
      this.sessionService.triggerSessionExpired();
      this.router.navigate(['/main-applcation-login']).then(() => {
        this.isRedirecting = false;
      });
      return false;
    }

    console.log('✅ Token valid - access granted');
    return true;
  }
}